import Hero from './Hero'
import Info from './Info'
import Services from './Services'
import LetsTalk from './LetsTalk'
import Testomonial from './Testomonial'
import Contact from './Contact'
import OurTeam from '../Commen/OurTeam'
import { Helmet } from 'react-helmet-async'

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Bluecoder - Website Design & Web Development Company In Nagpur</title>
                <meta name="description"
                    content="Bluecoder is a best website design & development company in Nagpur, we offer Website Designing & Development Services And also provide top class It services in Nagpur"
                    data-rh="true" />

                <meta name="keywords"
                    content="web design company, web design services, digital marketing company, web development services in Nagpur, BEST seo company Nagpur, website designing services in Nagpur, It company Nagpur, Software company Nagpur, ecommerce development company Nagpur" />
                <link rel="canonical" href="/"></link>
            </Helmet>
            <Hero />
            <Info />
            <Services />
            {/* <LetsTalk /> */}
            <Testomonial />
            {/* <OurTeam /> */}
            <Contact />
        </>
    )
}

export default Home